import { render, staticRenderFns } from "./EditRegtimeExcludeSetting.vue?vue&type=template&id=24a12213&scoped=true"
import script from "./EditRegtimeExcludeSetting.vue?vue&type=script&lang=js"
export * from "./EditRegtimeExcludeSetting.vue?vue&type=script&lang=js"
import style0 from "./EditRegtimeExcludeSetting.vue?vue&type=style&index=0&id=24a12213&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a12213",
  null
  
)

export default component.exports